import { useTranslation } from 'react-i18next'
import { BatteryPercentage } from 'components'
import { DeviceType as DT } from 'enums'
import { camelize, toFriendlyDate, toFriendlyTime } from 'utils'

import './styles.scss'

export default function SecurityDeviceInfo(props) {
  const { t } = useTranslation(null, { useSuspense: false })
  const { securityDevice: device } = props

  if (!device) return <></>
  return (
    <div className='security-device-info-comp'>
      <div className='battery-device-container row'>
        <p className='device-type'>{t(`device.type.${camelize(device.deviceType)}`)}</p>
        {device.deviceType === DT.lock && device.batteryPercentage != null &&
          <BatteryPercentage batteryPercentage={device.batteryPercentage} />
        }
      </div>

      <p className='subtitle'>{device.serialNumber}</p>

      {device?.disarmedBy && device?.disarmedAt && (
        <p className='subtitle'>
          {t('device.disarmedAt', {
            user: device.disarmedBy,
            date: toFriendlyDate(device.disarmedAt),
            time: toFriendlyTime(device.disarmedAt),
          })}
        </p>
      )}
      {device?.securityStatusUpdatedAt && (
        <p className='subtitle'>
          {t('device.securityStatusUpdatedAt', {
            date: toFriendlyDate(device.securityStatusUpdatedAt),
            time: toFriendlyTime(device.securityStatusUpdatedAt),
          })}
        </p>
      )}
    </div>
  )
}